
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 9a2 2 0 110-4 2 2 0 010 4zM7 7a3 3 0 116 0 3 3 0 01-6 0zm-1 8a3 3 0 013-3h2a3 3 0 013 3 1 1 0 01-1 1H7a1 1 0 01-1-1zm-1 0a4 4 0 014-4h2a4 4 0 014 4 2 2 0 01-2 2H7a2 2 0 01-2-2zm10.415 2h1.835a2 2 0 002-2 4 4 0 00-4-4H14c.379.284.716.621 1 1h.25a3 3 0 013 3 1 1 0 01-1 1h-1.334c-.096.37-.269.71-.501 1zM3 17h1.835a2.658 2.658 0 01-.5-1H3a1 1 0 01-1-1 3 3 0 013-3h.25a5.029 5.029 0 011-1H5a4 4 0 00-4 4 2 2 0 002 2zm9.95-7.297a3 3 0 100-5.405c.23.25.428.53.588.834a2 2 0 110 3.737c-.16.303-.359.583-.589.834zM5.996 10c.467 0 .91-.107 1.304-.297a4.01 4.01 0 01-.589-.835 2 2 0 110-3.737 4.01 4.01 0 01.589-.834A3 3 0 105.997 10z"}})])
          )
        }
      }
    